import Reveal from "@/components/site/Reveal";

const steps = [
  "Identifier les schémas émotionnels actifs",
  "Comprendre leur origine",
  "Travailler à leur restructuration",
  "Remettre du mouvement là où quelque chose s'est figé",
];

export default function Approach() {
  return (
    <section
      id="approche"
      data-testid="approach-section"
      className="py-24 md:py-32 bg-[#F3EEF4]"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-16 items-start">
        <div className="lg:col-span-5">
          <Reveal>
            <span className="text-sm uppercase tracking-[0.2em] text-[#C98FA3] font-medium">
              — Méthode
            </span>
            <h2 className="font-serif-display text-4xl md:text-5xl font-light mt-4 leading-[1.05]">
              Comprendre pour transformer
            </h2>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="mt-10 p-8 bg-white rounded-2xl border border-[#DDD7E2]">
              <p className="text-sm uppercase tracking-[0.18em] text-[#3A2E6E] font-medium mb-3">
                Cadre du travail
              </p>
              <p className="text-base text-[#5F6170] leading-relaxed">
                Ce travail se fait dans un cadre posé, progressif et respectueux de votre rythme.
              </p>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7 space-y-6">
          <Reveal>
            <p className="text-lg md:text-xl text-[#1E1E2A] leading-relaxed">
              Les difficultés actuelles peuvent avoir une origine plus ancienne :
              dans l'enfance, dans le vécu émotionnel, dans l'histoire familiale ou
              dans des mémoires plus précoces.
            </p>
          </Reveal>

          <Reveal delay={0.1}>
            <p className="text-base text-[#5F6170] leading-relaxed">
              Mon approche consiste à :
            </p>
          </Reveal>

          <div className="space-y-3 mt-2">
            {steps.map((s, i) => (
              <Reveal key={s} delay={0.15 + i * 0.07}>
                <div
                  data-testid={`approach-step-${i}`}
                  className="flex items-start gap-5 p-5 bg-white/80 backdrop-blur rounded-2xl border border-[#DDD7E2] hover:border-[#C98FA3] transition-colors"
                >
                  <span className="font-serif-display text-3xl text-[#C98FA3] leading-none flex-shrink-0 w-10">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <p className="text-base md:text-lg text-[#1E1E2A]">{s}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
